import { ReactNode, useCallback, useState } from "react";
import { Box } from "@mui/material";
import { List } from "src/components-mui/modules/underlying-lists-module/components/list";
import {
    UNDERLYING_LIST_COLUMN_GAP_PX,
    UNDERLYING_LIST_MOTIVES,
    UnderlyingListDaysCount,
    UnderlyingListMotive,
    UnderlyingListOverlayPlacement,
} from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.constants";
import { IUnderlyingLists } from "src/components-mui/modules/underlying-lists-module/underlying-lists-module.types";

interface IExpandedItem {
    motive: UnderlyingListMotive;
    isin: string;
}

interface IListsGridProps {
    lists: IUnderlyingLists;
    daysCount: UnderlyingListDaysCount;
    selectedMotive: UnderlyingListMotive;
    listIdPrefix: string;
    overlay: ReactNode | null;
}

const getOverlayPlacement = ({ listIndex }: { listIndex: number }) =>
    listIndex === 0 ? UnderlyingListOverlayPlacement.SpanningColumns : UnderlyingListOverlayPlacement.CompactOnly;

export const ListsGrid = ({ lists, daysCount, selectedMotive, listIdPrefix, overlay }: IListsGridProps) => {
    const [expandedItem, setExpandedItem] = useState<IExpandedItem | null>(null);

    const toggleItem = useCallback(({ motive, isin }: IExpandedItem) => {
        setExpandedItem(current => (current?.motive === motive && current.isin === isin ? null : { motive, isin }));
    }, []);

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" },
                columnGap: `${UNDERLYING_LIST_COLUMN_GAP_PX}px`,
                rowGap: 8,
                mt: { xs: 4, md: 0 },
            }}
        >
            {UNDERLYING_LIST_MOTIVES.map((motive, listIndex) => (
                <List
                    key={motive}
                    id={`${listIdPrefix}-${motive}`}
                    motive={motive}
                    list={lists[motive]}
                    daysCount={daysCount}
                    isSelected={motive === selectedMotive}
                    expandedIsin={expandedItem?.motive === motive ? expandedItem.isin : null}
                    onItemToggle={toggleItem}
                    overlay={overlay}
                    overlayPlacement={getOverlayPlacement({ listIndex })}
                />
            ))}
        </Box>
    );
};
